import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import Accordion from 'react-bootstrap/Accordion';
import theme from '../../../../assets/stylesheets/_settings.global.scss';
import { Container, FullWidthContentContainer } from '../shared/styles';
import Loading from '../../../shared/loading';
import { useGetQuestionCategories, useGetQuestions } from '../../../services/lwadmin/fund/question-service';
import Actions from './manage-qanda-questions-components/actions';
import Header from './manage-qanda-questions-components/header';
import Editor from './manage-qanda-questions-components/editor';
import Question from './manage-qanda-questions-components/question';
import useStore from './manage-qanda-questions-components/store-hook';

const Wrapper = ({ children }) => (
  <ThemeProvider theme={theme}>
    <Container>
      <FullWidthContentContainer>
        {children}
      </FullWidthContentContainer>
    </Container>
  </ThemeProvider>
);

Wrapper.propTypes = { children: PropTypes.node.isRequired };

const Title = styled.h1`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const plainQuestion = {
  order: 99,
  fundTypes: [],
  description: '',
};

export default function ManageQandaQuestions() {
  const setQsCats = useStore(state => state.setQsCats);
  const qs = useStore(state => state.qs);
  const set = useStore(state => state.set);
  const loadingRef = React.useRef();
  const [{ data: cdata, loading: cloading }, getCats] = useGetQuestionCategories();
  const [{ data: qdata, loading: qloading }, getQs] = useGetQuestions();
  const [collapsed, setCollapsed] = React.useState(true);
  const [creating, setCreating] = React.useState(false);

  React.useEffect(() => {
    loadingRef.current && loadingRef.current.toggle(cloading || qloading);
  }, [cloading, qloading]);

  React.useEffect(() => {
    const categories = _.get(cdata, 'categories', []);
    const questions = _.get(qdata, 'questions', []);
    categories.length && questions.length && setQsCats(questions, categories);
  }, [cdata, qdata, setQsCats]);

  useChangeAwareEffect(({ isMount }) => {
    if (!isMount) {
      return;
    }
    getCats();
    getQs();
  }, {});

  const actionsProps = {
    creating,
    enabled: collapsed,
    onRefresh: getQs,
    onCreate: () => setCreating(!creating),
  };

  const editorProps = {
    question: plainQuestion,
    onCancel: () => setCreating(false),
    onCreated: d => {
      set(state => {
        state.qs.unshift(d);
      });
      setCreating(false);
    },
  };

  return (
    <Wrapper>
      <>
        <Title>
          Manage Fund Q&A Questions
          <Actions {...actionsProps} />
        </Title>
        <Header />
        {!!creating && <Editor {...editorProps} />}
        <Loading ref={loadingRef} />
        {!(cloading || qloading) && !!qs.length && (
          <Accordion onSelect={e => setCollapsed(!e)}>
            {qs.map((q, i) => <Question key={`q-${q.id}`} qindex={i} />)}
          </Accordion>
        )}
      </>
    </Wrapper>
  );
}
